import { useEvent } from 'hooks'
import { feedbackMessengerWindowSelector } from './feedback-messenger-window.selector'
import { constant } from './feedback-messenger-window.constant'

const localStorageMessage = 'concept_message'

export const FeedbackMessengerWindow = (() => {
	const handleChange = () => {
		const feedbackMessengerWindow = feedbackMessengerWindowSelector.getFeedbackMessengerWindow()
		const feedbackMessengerWindowSubjectInput = feedbackMessengerWindowSelector.getFeedbackMessengerWindowSubjectInput()
		const feedbackMessengerWindowWysiwyg = feedbackMessengerWindowSelector.getFeedbackMessengerWindowWysiwyg()

		const onChange = useEvent<MouseEvent>(feedbackMessengerWindow, 'change')

		onChange.register(({ e }) => {
			if (e.target === feedbackMessengerWindowSubjectInput) {
				const requiredPart = feedbackMessengerWindow.getAttribute(constant.selector.requiredSubjectPart)

				if (requiredPart !== null && !feedbackMessengerWindowSubjectInput.value.startsWith(requiredPart, 0)) {
					feedbackMessengerWindowSubjectInput.value = `${requiredPart} ${feedbackMessengerWindowSubjectInput.value}`
				}
			}

			localStorage.setItem(
				localStorageMessage,
				JSON.stringify({
					subject: feedbackMessengerWindowSubjectInput.value,
					htmlContent: feedbackMessengerWindowWysiwyg.value,
				}),
			)
		})
	}

	const init = () => {
		handleChange()
	}

	return {
		init,
	}
})()
